/**
 * TaseronKararParcalari.jsx — iki taşeron ekranının ORTAK karar parçaları.
 *
 * Şimdilik tek parça var — kararı geri alma. (İmzalı form yükleme parçası ve "beyanı geri almak
 * paylaşım bayraklarını sıfırlar" uyarısı #382 ile kalktı: form ve bayrak yok, bkz.
 * firmaTaseronService.js başlığı.)
 */
import React, { useState } from "react";
import {
  Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner,
} from "reactstrap";
import { KAPI, KAPI_ADI, SEBEP_MAX } from "../../services/firmaTaseronService";
import { useTranslation } from "react-i18next";

/**
 * Bir kararı geri al — satır "Bekliyor"a döner, eski cevap tarihçeye yazılır.
 * `sebep` İSTEĞE BAĞLI (kapı kararlarının `redSebebi`sinin aksine).
 *
 * @param {object} row   firma-taseron satırı (null ise modal kapalı)
 * @param {number} kapi  KAPI.TASERON_BEYANI | KAPI.DEKORATOR_ONAYI
 * @param {boolean} personelAdina  personel başkası adına geri alıyorsa metin ona göre
 */
export function GeriAlModal({ row, kapi, personelAdina = false, onClose, onSubmit }) {
  const { t } = useTranslation("components");
  const [sebep, setSebep] = useState("");
  const [busy, setBusy] = useState(false);
  if (!row || !kapi) return null;
  const beyan = kapi === KAPI.TASERON_BEYANI;
  const taraf = beyan ? row.taseronFirmaAdi : row.anaFirmaAdi;

  return (
    <Modal isOpen toggle={() => !busy && onClose()}>
      <ModalHeader toggle={() => !busy && onClose()}>{KAPI_ADI[kapi]}{" "}{t("taseronKarar.geriAl")}</ModalHeader>
      <ModalBody>
        <p className="small text-muted mb-3">
          {personelAdina
            ? <><strong>{taraf}</strong>{" "}{t("taseronKarar.adinaVerilenCevap")}{" "}<strong>{t("taseronKarar.bekliyor")}</strong>{" "}{t("taseronKarar.durumunaDoner")}</>
            : <>{t("taseronKarar.cevabiniz")}{" "}<strong>{t("taseronKarar.bekliyor")}</strong>{" "}{t("taseronKarar.durumunaDonerVeYenidenYanitlayabilirsiniz")}</>}
          {t("taseronKarar.oncekiCevapSilinmezKayitAltinda")}
        </p>

        <Label className="small">{t("taseronKarar.sebepIstegeBagliEnFazla", { SEBEP_MAX })}</Label>
        <Input
          type="textarea" rows={2} value={sebep} maxLength={SEBEP_MAX}
          onChange={(e) => setSebep(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onClose} disabled={busy}>{t("taseronKarar.vazgec")}</Button>
        <Button
          color="warning" disabled={busy}
          onClick={async () => { setBusy(true); try { await onSubmit({ sebep }); } finally { setBusy(false); } }}
        >
          {busy ? <Spinner size="sm" /> : t("taseronKarar.geriAl2")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
